export default __webpack_public_path__ + "static/media/solidario9.01292b4e.jpeg";